import * as React from 'react';

const BottomBar: React.FunctionComponent = ({ children }) => {
  return (
    <div className="fixed bottom-0 left-0 p-4 w-screen bg-gray-100 shadow border border-gray-300 border-t-2">
      {children}
    </div>
  );
};

export default BottomBar;
